var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 7.50002H16.7084V10.3334H15.2917V7.50002Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 13.1667H16.7084V15.2917H18.8334V16.7084H16.7084V18.8334H15.2917V16.7084H13.1667V15.2917H15.2917V13.1667Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 21.6667H16.7084V24.5H15.2917V21.6667Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 15.2917V16.7084H10.3334V15.2917H7.50008Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 16.7084V15.2917H24.5001V16.7084H21.6667Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5834 0.416687H0.416748V31.5834H31.5834V0.416687ZM28.7501 15.2917V3.25002H16.7084V4.66669H15.2917V3.25002H3.25008V15.2917H4.66675V16.7084H3.25008V28.75H15.2917V27.3334H16.7084V28.75H28.7501V16.7084H27.3334V15.2917H28.7501Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWell);
export default __webpack_public_path__ + "static/media/Well.5d59588de8d6acd58737ebdb5265e66e.svg";
export { ForwardRef as ReactComponent };